import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
Vue.use(Vuex)

import activePropertySlides from './getters/activePropertySlides'

import loadConfig from '../../config'
const projectConfig = loadConfig(process.env.VUE_APP_PROJECT)

const isProd = process.env.VUE_APP_ENV === 'production'

// Data Paths
const configData = isProd ? '/data/config.json' : process.env.VUE_APP_API_HOST + '/config/touchscreen'
const navigationData = isProd ? '/data/navigation.json' : process.env.VUE_APP_API_HOST + '/navigation/touchscreen'
const pagesData = isProd ? '/data/pages.json' : process.env.VUE_APP_API_HOST + '/pages/touchscreen'
const livingOptionsData = isProd ? '/data/living-options.json' : process.env.VUE_APP_API_HOST + '/living-options/touchscreen'
const subsectionsData = isProd ? '/data/subsections.json' : process.env.VUE_APP_API_HOST + '/subsections/touchscreen'
const propertiesData = isProd ? '/data/properties.json' : process.env.VUE_APP_API_HOST + '/properties/touchscreen'
const dwellingsData = isProd ? '/data/dwellings.json' : process.env.VUE_APP_API_HOST + '/dwellings/touchscreen'
const packagesData = isProd ? '/data/packages.json' : process.env.VUE_APP_API_HOST + '/packages/touchscreen'
const turnkeysData = isProd ? '/data/properties.turnkey.listing.json' : process.env.VUE_APP_API_HOST + '/properties/turnkey/listing'

// Store Modules
import property from './property.module'
import animations from './animations.module'
import sounds from './sounds.module'
import sidebar from './sidebar.module'
import favourites from './favourites.module'
import interactions from './interactions.module'
import actions from './actions.module'
import filter from './filter.module'

export default new Vuex.Store({
  modules: {
    actions,
    animations,
    favourites,
    filter,
    interactions,
    property,
    sounds,
    sidebar
  },

  state: {
    assetsPath: isProd ? '/assets/' : process.env.VUE_APP_ASSETS_HOST + '/',
    version: process.env.VUE_APP_VERSION,
    deviceName: null,
    selector: null,

    config: [],
    navigation: [],
    pages: [],

    isBottomBarVisible: false,
    isMatterportAvailable: null,

    videowallHost: null,
    hideLiveHere: false,
    hideLivingOptions: null,
    hideNavItems: null,
    homeUrl: null,
    appScale: 1,

    styleTemplate: {},

    projectConfig: projectConfig,
    language: projectConfig.languages[0],
    languages: projectConfig.languages,

    labels: projectConfig.labels,

    activePackageSlideId: '',
    activeTagsOverride: null,
    activeBackgroundOverride: '',

    isLayoutSwitched: false,

    urlHistory: [],

    isEmailModalActive: false
  },

  getters: {
    projectConfig (state) { 
      return state.projectConfig
    },
    activeCategory (state) {
      if (state.route.params.categoryId) {
        return `category/${state.route.params.categoryId}`
      }
    },

    activeBottomBar (state, getters) {
      const routeName = state.route.name

      if (routeName === 'rest') {
        return []
      }

      let activePageNavigationItem = null
      if (state.route.params.categoryId) {
        activePageNavigationItem = _.find(getters.navigation, category => {
          return category._id === state.route.params.categoryId
        })
      } else if (getters.navigation) {
        getters.navigation.forEach(category => {
          if (state.route.path.includes(category.customRoute)) {
            activePageNavigationItem = category
          }
        })
      }
      return activePageNavigationItem && activePageNavigationItem.children ? activePageNavigationItem.children : []
    },

    activeBottomBarPageLabel () {
      // dodgey af but cityscape things
      return document.querySelector('.bottom-bar .router-link-active').innerText.toLowerCase().replaceAll(' ', '-')
    },

    activeSubBottomBar (state, getters, rootState) {
      const routeName = state.route.name

      if (routeName === 'page') {
        let activePageSubNavigation = []
        if (getters.activeBottomBar && getters.activePage) {
          const activePageId = getters.activePage._id
          
          getters.activeBottomBar.forEach(parentNavigationItem => {
            if (parentNavigationItem.pageId === activePageId) {
              activePageSubNavigation = parentNavigationItem.children
            }
            
            if (parentNavigationItem.children) {
              parentNavigationItem.children.forEach(childNavigationItem => {
                if (childNavigationItem.pageId === activePageId) {
                  activePageSubNavigation = parentNavigationItem.children
                }
              })
            }
          })
        }
        if (rootState.hideNavItems) activePageSubNavigation = activePageSubNavigation.filter(item => !rootState.hideNavItems.split(',').includes(item._id))
        return activePageSubNavigation
      }
      
      // check the LIVE section for manually created navigation items
      if (routeName !== 'rest') {      
        const liveSubNavItems = state.navigation[0].children.find(navItem => navItem.isLiveSection)
        let liveSectionNavItems = JSON.parse(JSON.stringify(liveSubNavItems.children))

        let hasNavItemLand = false
        let hasNavItemPackages = false
        let hasNavItemTownhouses = false
        let hasNavItemHouses = false
        let hasNavItemDwellings = false
        let hasNavItemTurnkey = false

        liveSectionNavItems.forEach(item => {
          if (item.customRoute && item.customRoute.includes('live/land')) {
            hasNavItemLand = true
          }

          if (item.customRoute && item.customRoute.includes('live/packages')) {
            hasNavItemPackages = true
          }

          if (item.customRoute && item.customRoute.includes('live/townhouses')) {
            hasNavItemTownhouses = true
          }

          if (item.customRoute && item.customRoute.includes('live/houses')) {
            hasNavItemHouses = true
          }
          
          if (item.customRoute && item.customRoute.includes('live/apartments')) {
            hasNavItemApartments = true
          }

          if (item.customRoute && item.customRoute.includes('live/dwellings')) {
            hasNavItemDwellings = true
          }

          if (item.customRoute && item.customRoute.includes('live/turnkey')) {
            hasNavItemTurnkey = true
          }
        })

        // add live nav items if not manually added
        if (!hasNavItemLand) {
          if (getters['property/livingOptionsLand'] && getters['property/livingOptionsLand'].length) {
            liveSectionNavItems.push({
              'to': `/${getters.activeCategory}/live/land`,
              '_id': 'live-land',
              'label':{
                'en': rootState.styleTemplate['land-page']['label'] ? rootState.styleTemplate['land-page']['label'] : 'Land for sale'
              }
            })
          }
        }

        if (!hasNavItemTownhouses) {
          if (getters['property/livingOptionsTownhouses'] && getters['property/livingOptionsTownhouses'].length) {
            liveSectionNavItems.push({
              'to': `/${getters.activeCategory}/live/townhouses`,
              '_id': 'live-townhouse',
              'label':{
                'en': 'Townhouses'
              }
            })
          }
        }

        if (!hasNavItemHouses) {
          if (getters['property/livingOptionsHouses'] && getters['property/livingOptionsHouses'].length) {
            liveSectionNavItems.push({
              'to': `/${getters.activeCategory}/live/houses`,
              '_id': 'live-house',
              'label':{
                'en': 'Houses'
              }
            })
          }
        }
        
        if (!hasNavItemDwellings) {
          if (rootState.styleTemplate['dwelling-page']['active'] && getters['property/dwellings'] && getters['property/dwellings'].length) {
            liveSectionNavItems.push({
              'to': `/${getters.activeCategory}/live/dwellings`,
              '_id': 'live-dwelling',
              'label':{
                'en': rootState.styleTemplate['dwelling-page']['label'] ? rootState.styleTemplate['dwelling-page']['label'] : 'Dwellings'
              }
            })
          }
        }

        if (!hasNavItemTurnkey) {
          if (rootState.styleTemplate['turnkey-page']['active'] && getters['property/turnkeys'] && getters['property/turnkeys'].length) {
            liveSectionNavItems.push({
              'to': `/${getters.activeCategory}/live/turnkeys`,
              '_id': 'live-turnkeys',
              'label':{
                'en': rootState.styleTemplate['turnkey-page']['label'] ? rootState.styleTemplate['turnkey-page']['label'] : 'Turnkey Homes'
              }
            })
          }
        }

        if (!hasNavItemPackages) {
          if (rootState.styleTemplate['package-page']['active'] && getters['property/livingOptionsPackages'] && getters['property/livingOptionsPackages'].length) {
            liveSectionNavItems.push({
              'to': `/${getters.activeCategory}/live/packages`,
              '_id': 'live-packages',
              'label':{
                'en': rootState.styleTemplate['package-page']['label'] ? rootState.styleTemplate['package-page']['label'] : 'House & Land'
              }
            })
          }
        }

        if (rootState.styleTemplate['display-homes-page']['active']) {
          liveSectionNavItems.push({
            'to': `/${getters.activeCategory}/live/display-homes`,
            '_id': 'display-homes',
            'label':{
              'en': rootState.styleTemplate['display-homes-page']['label'] || 'Display Homes'
            }
          })
        }

        if (rootState.hideNavItems) liveSectionNavItems = liveSectionNavItems.filter(item => !rootState.hideNavItems.split(',').includes(item._id))
        return liveSectionNavItems
      }

      return []
    },

    activePage (state) {
      let activePage = null
      if (state.route.params.pageId) {
        activePage = _.find(state.pages, page => {
          return page._id === state.route.params.pageId
        })
      }
      return activePage
    },

    activeBackground (state, getters) {
      const routeName = state.route.name
      const config = state.config

      if (getters.activeBackgroundOverride) {
        return state.assetsPath + getters.activeBackgroundOverride
      }

      if (getters.activePage) {
        const bgImage = getters.activePage.backgroundImage[state.language.code] || getters.activePage.backgroundImage['en']
        return state.assetsPath + bgImage
      }

      if (getters.activePackageSlide) {
        return state.assetsPath + getters.activePackageSlide.backgroundImage
      }

      if (routeName === 'live') {
        return state.assetsPath + config.liveHereSelectionBackground
      }

      if (routeName === 'living-entry') {
        return state.assetsPath + (config.liveHereBackground[state.language.code] || config.liveHereBackground['en'])
      }

      if (routeName === 'live-display-homes' || routeName === 'live-display-homes-property') {
        return state.assetsPath + getters['property/activeSubsection'].backgroundImage
      }

      if (routeName === 'living-option' && getters['property/activeLivingOption']) {
        const bgImage = getters['property/activeLivingOption'].backgroundImage[state.language.code] || getters['property/activeLivingOption'].backgroundImage['en']
        return state.assetsPath + bgImage
      }

      if (['subsection', 'property'].includes(routeName) && getters['property/activeSubsection']) {
        const bgImage = getters['property/activeSubsection'].backgroundImage[state.language.code] || getters['property/activeSubsection'].backgroundImage['en']
        return state.assetsPath + bgImage
      }

      if (['packages', 'dwellings', 'favourites'].includes(routeName)) {
        if (['package-modal', 'dwelling-modal', 'favourite-modal', 'favourites'].includes(state.route.from.name)) {
          return state.animations.animateBackground
        }
      }

      if (['package-modal', 'dwelling-modal', 'favourite-modal'].includes(routeName)) {
        return state.animations.animateBackground
      }

      return ''
    },

    activeSlides (state, getters) {
      const routeName = state.route.name
      const pathway = state.route.params.pathway

      if (getters.activePage && getters.activePage.interactiveSlides) {
        return getters.activePage.interactiveSlides
      }

      if (['living-entry'].includes(routeName)) {
        if (projectConfig.useSidebarSubnavigation) return []
        if (state.styleTemplate['hide-livingoption-slides']) return []
        switch (pathway) {
          case 'masterplan':
            return _.sortBy(getters['property/livingOptions'].filter(option => !option.isVisuallyHidden), livingOption => {
              const [marker] = livingOption.markers || []
              return marker ? marker.x : Number.MAX_SAFE_INTEGER
            }).map(livingOption => {
              return {
                _id: livingOption._id,
                livingOptionId: livingOption._id,
                label: livingOption.displayName || livingOption.label,
                cardBackgroundImage: livingOption.cardBackgroundImage,
                backgroundImage: livingOption.backgroundImage
              }
            })
          case 'land':
            return _.sortBy(getters['property/livingOptionsLand'].filter(option => !option.isVisuallyHidden), livingOption => {
              const [marker] = livingOption.markers || []
              return marker ? marker.x : Number.MAX_SAFE_INTEGER
            }).map(livingOption => {
              return {
                _id: livingOption._id,
                livingOptionId: livingOption._id,
                label: livingOption.displayName || livingOption.label,
                cardBackgroundImage: livingOption.cardBackgroundImage,
                backgroundImage: livingOption.backgroundImage
              }
            })

          case 'townhouses':
            return _.sortBy(getters['property/livingOptionsTownhouses'], livingOption => {
              const [marker] = livingOption.markers || []
              return marker ? marker.x : Number.MAX_SAFE_INTEGER
            }).map(livingOption => {
              return {
                _id: livingOption._id,
                livingOptionId: livingOption._id,
                label: livingOption.displayName || livingOption.label,
                cardBackgroundImage: livingOption.cardBackgroundImage,
                backgroundImage: livingOption.backgroundImage
              }
            })

          case 'houses':
            return _.sortBy(getters['property/livingOptionsHouses'], livingOption => {
              const [marker] = livingOption.markers || []
              return marker ? marker.x : Number.MAX_SAFE_INTEGER
            }).map(livingOption => {
              return {
                _id: livingOption._id,
                livingOptionId: livingOption._id,
                label: livingOption.displayName || livingOption.label,
                cardBackgroundImage: livingOption.cardBackgroundImage,
                backgroundImage: livingOption.backgroundImage
              }
            })

          case 'apartments':
            return _.sortBy(getters['property/livingOptionsApartments'], livingOption => {
              const [marker] = livingOption.markers || []
              return marker ? marker.x : Number.MAX_SAFE_INTEGER
            }).map(livingOption => {
              return {
                _id: livingOption._id,
                livingOptionId: livingOption._id,
                label: livingOption.displayName || livingOption.label,
                cardBackgroundImage: livingOption.cardBackgroundImage,
                backgroundImage: livingOption.backgroundImage
              }
            })
        
          default:
            break;
        }
      }

      if (['living-option', 'subsection', 'property'].includes(routeName) && !projectConfig.useSidebarSubnavigation && getters['property/activeLivingOption']) {
        const subsections = getters['property/activeSubsections']

        if (subsections && subsections.length >= 1) {
          return _.sortBy(subsections, subsection => {
            const [marker] = subsection.markers || []
            return marker ? marker.x : Number.MAX_SAFE_INTEGER
          })
        } else {
          return []
        }
      }

      return []
    },

    activeBackgroundOverride (state) {
      return state.activeBackgroundOverride
    },

    activeTagsOverride (state) {
      return state.activeTagsOverride
    },

    activePageTags (state, getters, rootState, rootGetters) {
      let activePageTags = []

      if (getters.activeTagsOverride !== null) {
        return getters.activeTagsOverride
      }

      if (
        state.route.name === 'living-entry' &&
        rootGetters['config'].liveHereMasterplanTags &&
        rootGetters['config'].liveHereMasterplanTags.length
      ) {
        return rootGetters['config'].liveHereMasterplanTags
      }

      if (
        state.route.name === 'living-option' &&
        rootGetters['property/activeLivingOption'] &&
        rootGetters['property/activeLivingOption'].tags
      ) {
        return rootGetters['property/activeLivingOption'].tags
      }

      if (
        state.route.name === 'subsection' &&
        rootGetters['property/activeSubsection'] &&
        rootGetters['property/activeSubsection'].tags
      ) {
        return rootGetters['property/activeSubsection'].tags
      }

      if (getters.activePage && getters.activePage.tags) {
        activePageTags = _.filter(getters.activePage.tags, tag => {
          return tag.type !== 'feature'
        })

        activePageTags = _.sortBy(activePageTags, tag => { 
          return tag.pos.x
        })
      }

      return activePageTags
    },

    activePackageSlide (state, getters) {
      const activePackage = getters.activePropertySlides.find(_package => _package._id === state.activePackageSlideId)

      if (activePackage) {
        return activePackage
      }

      return null
    },

    activePropertySlides,

    activePropertyModal (state, getters, rootState) {
      const routeName = rootState.route.name

      if (routeName === 'property' || routeName === 'carousel') {
        const property = getters['property/activeProperty']
        if (!property) return null
        const dwelling = property.dwelling

        const fpImages = dwelling.floorplanImages[state.language.code] || dwelling.floorplanImages['en']

        const images = property.dwelling ? [...dwelling.facadeImages, ...fpImages, ...dwelling.galleryImages] : [...property.viewImages, ...property.galleryImages]
        const landPrice = property.price ? property.price.toLocaleString('en-AU', { style: 'currency', currency: getters.projectConfig.currency, maximumSignificantDigits: 10 }) : false 
        const iframes = dwelling ? [...property.iframes, ...dwelling.iframes] : property.iframes

        const type = property.dwelling ? 'turnkey' : 'land'

        return {
          _id: property._id,
          description: dwelling ? dwelling.description : '',
          features: dwelling ? dwelling.featureList : '',
          frontage: property.frontage,
          images: images,
          type: type,
          labelTitle: state.labels.name[state.language.code] || state.labels.name['en'],
          label: property.label,
          price: landPrice,
          priceLabel: state.labels.price,
          viewLabel: property.viewLabel,
          landSize: property.size,
          dwellingSize: dwelling ? dwelling.size : '',
          status: _.kebabCase(property.status),
          dwelling: dwelling,
          suitableDwellings: property.suitableDwellings,
          associatedPackages: property.associatedPackages,
          iframes: iframes
        }
      }

      if (routeName === 'package-modal') {
        const modalId = rootState.route.params.packageId
        const _package = getters['property/packages'].find(_package => _package._id === modalId)
        if (!_package ) return null

        if (_package && _package.property &&_package.dwelling) {

          const subsection = getters['property/subsections'].find(subsection => subsection._id === _package.property.subsectionId)

          const category = state.navigation[0]._id

          let associatedLotPath = ''

          // if subsection is found
          if (subsection) {
            associatedLotPath = `/category/${category}/live/land/${_package.property.livingOptionId}/subsection/${_package.property.subsectionId}/property/${_package.property._id}?activeSubsectionId=${_package.property.subsectionId}`
          }

          
          return {
            _id: _package._id,
            description: _package.dwelling.description,
            features: _package.dwelling.featureList,
            images: [..._package.dwelling.facadeImages, ...(_package.dwelling.floorplanImages[state.language.code] || _package.dwelling.floorplanImages.en), ..._package.dwelling.galleryImages],
            labelTitle: 'House Name',
            priceLabel: _package.priceLabel || 'Price',
            label: _package.label,
            price: _package.price.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 10 }) ,
            size: _package.property.size,
            associatedLotPath: associatedLotPath,
            iframes: [ ..._package.property.iframes, ..._package.dwelling.iframes]
          }
        } else {
          return null
        }
      }

      if (routeName === 'dwelling-modal') {
        const modalId = rootState.route.params.dwellingId
        const dwelling = getters['property/dwellings'].find(dwelling => dwelling._id === modalId)
        if (!dwelling) return null

        if (dwelling) {
          return {
            _id: dwelling._id,
            description: dwelling.description,
            features: dwelling.featureList,
            images: [...dwelling.facadeImages, ...(dwelling.floorplanImages[state.language.code] || dwelling.floorplanImages.en), ...dwelling.galleryImages],
            labelTitle: 'Name',
            label: dwelling.label,
            price: dwelling.price ? dwelling.price.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 10 }) : '',
            dwellingSize: dwelling.size,
            dwelling: dwelling,
            iframes: [ ...dwelling.iframes ]
          }
        } else {
          return null
        }
      }

      if (routeName === 'turnkey-modal') {
        const modalId = rootState.route.params.propertyId
        const turnkey = getters['property/turnkeys'].find(property => property._id === modalId)
        if (!turnkey) return null
        if (turnkey) {
          return {
            _id: turnkey._id,
            description: turnkey.description,
            dwelling: turnkey.dwelling,
            features: turnkey.featureList,
            images: [...turnkey.images],
            labelTitle: 'Name',
            label: turnkey.name,
            viewLabel: turnkey.viewLabel,
            priceLabel: turnkey.priceLabel || 'Price',
            price: turnkey.price ? turnkey.price.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 10 }) : '',
            dwellingSize: turnkey.dwellingSize,
            landSize: turnkey.landSize,
            iframes: turnkey.iframes
          }
        } else {
          return null
        }
      }

      if (routeName === 'live-display-homes-property') {
        const property = getters['property/activeProperty']
        if (!property) return null

        const dwelling = property.dwelling
        if (!dwelling) return null
        
        if (property && dwelling) {

          const images = [...dwelling.facadeImages, ...dwelling.galleryImages, ...(dwelling.floorplanImages[state.language.code] || dwelling.floorplanImages.en)]
  
          return {
            type: 'display-home',
            _id: property._id,
            description: dwelling.description,
            features: dwelling.featureList,
            images: images,
            labelTitle: 'House Design',
            label: dwelling.displayName[state.language.code] || dwelling.displayName['en'] || dwelling.label,
            price: false,
            landSize: property.size,
            viewLabel: property.viewLabel,
            dwellingSize: dwelling.size,
            status: 'available',
            dwelling: dwelling,
            displayHomeHours: property.displayHomeHours,
            builderDescription: dwelling.builderDescription,
            builderImage: dwelling.builderImage,
            builderLabel: dwelling.builderLabel,
            iframes: [...property.iframes, ...dwelling.iframes]
  
            // associatedPackages: property.associatedPackages
          }
        }
      }


      if (routeName === 'favourite-modal') {
        const modalId = rootState.route.params.favouriteId
        const _package = getters['property/livingOptionsPackages'].find(_package => _package._id === modalId)
        const land = getters['property/land'].find(land => land._id === modalId)
        const dwelling = getters['property/dwellings'].find(dwelling => dwelling._id === modalId)
        const turnkey = getters['property/turnkeys'].find(property => property._id === modalId)
        if (!_package) return null
        if (_package) {
          return {
            _id: _package._id,
            description: _package.dwelling.description,
            features: _package.dwelling.featureList,
            images: [...dwelling.facadeImages, ...(_package.dwelling.floorplanImages[state.language.code] || _package.dwelling.floorplanImages.en), ..._package.dwelling.galleryImages],
            labelTitle: 'House Name',
            label: _package.label,
            viewLabel: _package.viewLabel,
            priceLabel: _package.property.priceLabel || 'Price',
            price: _package.price.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 10 }),
            size: _package.property.size,
            iframes: [ ..._package.property.iframes, ..._package.dwelling.iframes]
          }
        } else if (land) {
          return {
            _id: land._id,
            description: '',
            features: '',
            images: [...land.viewImages, ...land.galleryImages],
            labelTitle: 'Name',
            label: land.label,
            viewLabel: land.viewLabel,
            priceLabel: land.priceLabel || 'Price',
            price: land.price ? land.price.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 10 }) : null,
            size: land.size,
            iframes: [ ...land.iframes]
          }
        } else if (dwelling) {
          return {
            _id: dwelling._id,
            description: dwelling.description,
            features: dwelling.featureList,
            images: [...dwelling.facadeImages, ...(dwelling.floorplanImages[state.language.code] || dwelling.floorplanImages.en), ...dwelling.galleryImages],
            labelTitle: 'Name',
            label: dwelling.label,
            price: dwelling.price ? dwelling.price.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 10 }) : '',
            dwellingSize: dwelling.size,
            iframes: [...dwelling.iframes]
          }
        } else if (turnkey) {
          return {
            _id: turnkey._id,
            description: turnkey.description,
            features: turnkey.featureList,
            images: turnkey.images,
            labelTitle: 'Name',
            label: turnkey.name,
            viewLabel: turnkey.viewLabel,
            priceLabel: turnkey.priceLabel || 'Price',
            price: turnkey.price ? turnkey.price.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 10 }) : '',
            dwellingSize: turnkey.dwellingSize,
            landSize: turnkey.landSize,
            iframes: [ ...turnkey.iframes ]
          }
        } else {
          return null
        }
      }

      return null
    },

    activeBackLink (state) {
      return state.urlHistory[state.urlHistory.length - 1]
    },

    config (state) {
      return state.config
    },

    navigation (state) {
      let navigation = JSON.parse(JSON.stringify(state.navigation))
      if (navigation && navigation.length) {
        navigation.forEach(navigationCategory => {
          navigationCategory.children = _.sortBy(navigationCategory.children, child => child.order)
        })
      }
      return navigation
    },

    language (state) {
      return state.language
    },

    languages (state) {
      return state.languages
    },

    appScale (state) {
      return state.appScale
    },

    styleTemplate (state) {
      return state.styleTemplate
    }
  },

  mutations: {
    SET_APP_SCALE (state, scale) {
      state.appScale = scale
    },

    SET_CONFIG (state, config) {
      state.config = config
    },

    SET_MATTERPORT_AVAILABILITY (state, is_available) {
      state.isMatterportAvailable = is_available
    },

    SET_NAVIGATION (state, navigation) {
      state.navigation = navigation
    },

    SET_PAGES (state, pages) {
      state.pages = pages
    },

    SET_LANGUAGE (state, language) {
      state.language = language
    },

    SET_ACTIVE_PACKAGE_SLIDE_ID (state, id) {
      state.activePackageSlideId = id
    },

    SET_ACTIVE_BACKGROUND_OVERRIDE (state, background) {
      state.activeBackgroundOverride = background
    },

    SET_ACTIVE_TAGS_OVERRIDE (state, tags) {
      state.activeTagsOverride = tags
    },

    SET_STYLE_TEMPLATE (state, styleTemplate) {
      state.styleTemplate = styleTemplate
    },

    SET_IS_LAYOUT_SWITCHED (state, switchState) {
      state.isLayoutSwitched = switchState
    },

    ADD_URL_TO_HISTORY (state, url) {
      state.urlHistory.push(url)
    },

    SPLICE_HISTORY_FROM_URL (state, url) {
      const urlIndex = state.urlHistory.indexOf(url)
      
      state.urlHistory.splice(urlIndex, state.urlHistory.length)
    },

    CLEAR_URL_HISTORY (state) {
      state.urlHistory = []
    },

    SET_IS_EMAIL_MODAL_ACTIVE (state, payload) {
      state.isEmailModalActive = payload
    }
  },

  actions: {
    snitch ({ state }) {
      axios.get(`https://snitch.sensoreal.com.au/touch-seen/${state.deviceName}`).catch(e => {
        console.error(e)
      })
    },

    async fetchMatterportAvailability ({ state, commit }) {
      // check the cached state so we dont make unnecessary requests
      if (state.isMatterportAvailable !== null) {
        return state.isMatterportAvailable
      } else {
        await axios.get('https://my.matterport.com', {
          timeout: 5000,
        }).then(() => {
          commit('SET_MATTERPORT_AVAILABILITY', true)
        }).catch(e => {
          if (e.response && e.response.status == 403) {
            commit('SET_MATTERPORT_AVAILABILITY', true)
          } else {
            commit('SET_MATTERPORT_AVAILABILITY', true)
          }
        }).finally(() => {
          return state.isMatterportAvailable
        })
      }
    },

    async fetchData ({ commit }) {
      await axios.get(configData).then(res => {
        const configItems = res.data.config
        let configObject = {}
        configItems.map(el => {
          configObject[el.key] = el.value
        })
        commit('SET_CONFIG', configObject)
      }).catch(err => {
        console.warn(err)
      })

      await axios.get(navigationData).then(res => {
        commit('SET_NAVIGATION', res.data.categories)
      }).catch(err => {
        console.warn(err)
      })

      await axios.get(pagesData).then(res => {
        commit('SET_PAGES', res.data)
      }).catch(err => {
        console.warn(err)
      })

      await axios.get(livingOptionsData).then(res => {
        commit('property/SET_LIVING_OPTIONS', res.data)
      }).catch(err => {
        console.warn(err)
      })

      await axios.get(subsectionsData).then(res => {
        commit('property/SET_SUBSECTIONS', res.data)
      }).catch(err => {
        console.warn(err)
      })
      
      await axios.get(propertiesData).then(res => {
        commit('property/SET_PROPERTIES', res.data)
      }).catch(err => {
        console.warn(err)
      })
      
      await axios.get(dwellingsData).then(res => {
        commit('property/SET_DWELLINGS', res.data)
      }).catch(err => {
        console.warn(err)
      })
      
      await axios.get(packagesData).then(res => {
        commit('property/SET_PACKAGES', res.data)
      }).catch(err => {
        console.warn(err)
      })

      await axios.get(turnkeysData).then(res => {
        commit('property/SET_TURNKEYS', res.data)
      }).catch(err => {
        console.warn(err)
      })
    },

    toggleBottomBarVisibility ({ state }) {
      state.isBottomBarVisible = !state.isBottomBarVisible
    },
    
    triggerVideo ({ state }, videoFilename) {
      if (state.videowallHost && videoFilename) {
        console.log(`GET ${state.videowallHost}/play/${videoFilename}`)
        axios.get(`${state.videowallHost}/play/${videoFilename}`)
      }
    }
  }
})
